//
//
//
//
//
//
//
//
//

import VueHorizontal from 'vue-horizontal'

export default {
  components: { VueHorizontal },
  props: {
    section: {
      default: null
    },
    disabled: {
      default: null
    }
  },
  watch: {
    section: function () {
      this.$nextTick(() => {
        //this.$refs.horizontal.refresh(console.log)
      })
    }
  },
  mounted() {
    //this.$refs.horizontal.scrollToIndex(1)
  }
}
